import './clientEntry';
import './initializeI18n';

import {
  buildClientApp,
  generateConversationalCarleadConfig,
} from '@retail/funnel-components';
import { initRUM, patchRoutesWithRUM } from '@retail/funnel-rum';
import pckJson from '../package.json';
import clientRoutes from './clientRoutes';
import { funnelOptions } from './funnelOptions';

const appConfig = generateConversationalCarleadConfig(
  'fr',
  pckJson,
  funnelOptions,
);

initRUM(appConfig);

buildClientApp(appConfig, patchRoutesWithRUM(clientRoutes));
